module.exports = __webpack_public_path__ + "static/img/polygon.e237d80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spf/polygon.png
// module id = ./src/assets/spf/polygon.png
// module chunks = 1